import { ReactNode } from 'react'
import Logo from 'components/Logo'
import {
  AuthTemplateWrapper,
  ContentWrapper,
  LeftPart,
  Header,
  RightPart,
  RightPartImg
} from './styles'

interface IProps {
  children: ReactNode,
  rightPartImg: any,
  rightPartMaxWidth?: number,
  headerRightContent?: ReactNode
}

const AuthTemplate = (props: IProps) => {
  const { children, rightPartImg, rightPartMaxWidth, headerRightContent } = props

  return (
    <AuthTemplateWrapper>
      <Header>
        <Logo color="blue" />

        {headerRightContent}
      </Header>

      <ContentWrapper>
        <LeftPart>{children}</LeftPart>

        <RightPart maxWidth={rightPartMaxWidth || 360}>
          <RightPartImg src={rightPartImg} />
        </RightPart>
      </ContentWrapper>
    </AuthTemplateWrapper>
  )
}

export default AuthTemplate
